import './style.scss'

import React, { Component } from 'react'

import Icon from 'components/UI/Icon'
import Modal from 'components/UI/Modal'
import PropTypes from 'prop-types'
import infoIcon from 'img/info.svg'

class InputHelp extends Component {
    handleClose() {
        this.props.onClose()
    }
    handleClick() {
        this.props.onClick()
    }
    render() {
        const { show, children } = this.props
        return (
            <div className="input-help">
                <Icon svg={infoIcon} onClick={() => this.handleClick()} />
                {show && (
                    <Modal show={true} onClose={() => this.handleClose()}>
                        {children}
                    </Modal>
                )}
            </div>
        )
    }
}

InputHelp.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
}

export default InputHelp
